import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { yearChecklistGrid } from '../+store/assessementChecklist/checklistItems';

const styles = () => ({
  grid: {
    display: 'grid',
    gridTemplateRows: 'repeat(5, auto)',
    gridAutoFlow: 'column',
    columnGap: 20,
    rowGap: 2,
    justifyContent: 'start',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 120,
  },
  yesIcon: {
    color: '#4caf50',
    marginRight: 6,
    fontSize: 16,
  },
  pendingIcon: {
    color: '#78909c',
    marginRight: 6,
    fontSize: 16,
  },
  label: {
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
});

// Compact A-F readiness for a single rating year, laid out column-major into 5 rows x 3
// columns from the group's year node in the raw assessmentChecklist.
const FileReadiness = ({ yearNode, classes }) => (
  <div className={classes.grid}>
    {yearChecklistGrid(yearNode).map((item, i) =>
      item.spacer ? (
        <div className={classes.item} key={`spacer-${i}`} />
      ) : (
        <div className={classes.item} key={item.label}>
          <Icon className={item.status ? classes.yesIcon : classes.pendingIcon}>
            {item.status ? 'check_circle' : 'radio_button_unchecked'}
          </Icon>
          <Typography className={classes.label}>{item.label}</Typography>
        </div>
      )
    )}
  </div>
);

FileReadiness.propTypes = {
  yearNode: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FileReadiness);
